import { createEntityAdapter, createSelector, createSlice } from '@reduxjs/toolkit';
import { setDefinitions } from '../../actions/SetDefinitions';
const adapter = createEntityAdapter({});
const initialGroupsState = {};
const initialState = adapter.getInitialState({
    groups: initialGroupsState
});
function comparePD(a, b) {
    const diff = a.ord - b.ord;
    if (diff == 0) {
        return a.device_id - b.device_id;
    }
    else {
        return diff;
    }
}
export const panelDevicesSlice = createSlice({
    name: 'panel_devices',
    initialState,
    reducers: {
        panelDevicesCleared(s) {
            adapter.removeAll(s);
            s.groups = {};
        },
        panelDeviceDeleted(s, action) {
            const id = action.payload;
            const item = s.entities[id];
            if (!item)
                return;
            const gid = item.panel_group_id;
            if (s.groups[gid]) {
                s.groups[gid] = s.groups[gid].filter((x) => x !== id);
                if (s.groups[gid].length === 0)
                    delete s.groups[gid];
            }
            adapter.removeOne(s, id);
        },
        panelDeviceUpdated(s, action) {
            const item = action.payload;
            const oldItem = s.entities[item.id];
            if (oldItem) {
                const oldGroup = oldItem.panel_group_id;
                s.groups[oldGroup] = s.groups[oldGroup].filter((x) => x !== oldItem.id);
            }
            adapter.setOne(s, item);
            const newGroup = item.panel_group_id;
            // insert maintaining sort by name (example comparator)
            const arr = s.groups[newGroup];
            let i = 0;
            while (i < arr.length) {
                const other = s.entities[arr[i]];
                if (!other)
                    break;
                if (comparePD(item, other) < 0)
                    break;
                i++;
            }
            arr.splice(i, 0, item.id);
        }
    },
    extraReducers: builder => {
        builder
            .addCase(setDefinitions, (s, action) => {
            adapter.setAll(s, action.payload.panel_devices);
            s.groups = {};
            for (const d of action.payload.panel_devices) {
                if (s.groups[d.panel_group_id] == undefined)
                    s.groups[d.panel_group_id] = [];
                s.groups[d.panel_group_id].push(d.id);
            }
            for (const g in s.groups) {
                s.groups[g].sort((a, b) => comparePD(s.entities[a], s.entities[b]));
            }
        });
    },
});
export const { panelDevicesCleared, panelDeviceDeleted, panelDeviceUpdated, } = panelDevicesSlice.actions;
export const panelDeviceAdded = panelDeviceUpdated;
export default panelDevicesSlice.reducer;
export const allPanelDevices = adapter.getSelectors().selectAll;
export const panelDevicesInGroup = createSelector.withTypes()([
    s => s.groups,
    s => s.entities,
    (s, arg) => arg,
], (groups, entities, arg) => {
    var _a;
    const ids = (_a = groups[arg]) !== null && _a !== void 0 ? _a : [];
    return ids.map(id => entities[id]).filter(s => s != undefined);
});
